import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import Events from "./pages/Events";
import Gallery from "./pages/Gallery";
import DanaSchedule from "./pages/DanaSchedule";
import Donate from "./pages/Donate";
import Teachings from "./pages/Teachings";
import BuddhaLife from "./pages/BuddhaLife";
import Contact from "./pages/Contact";
import VesakRegistration from "./pages/VesakRegistration";
import VesakAdmin from "./pages/VesakAdmin";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/events" element={<Events />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/dana-schedule" element={<DanaSchedule />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/teachings" element={<Teachings />} />
          <Route path="/buddha-life" element={<BuddhaLife />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/vesak-registration" element={<VesakRegistration />} />
          <Route path="/vesak-admin" element={<VesakAdmin />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
